"use strict";

var React = require("react");
var Input = require("react-bootstrap").Input;
var Button = require("react-bootstrap").Button;
var cx = require("classnames");

var ErrorModal = React.createClass({
    render: function() {
      var calloutClasses = cx({
          "bs-callout": true,
          "bs-callout-danger": true,
          "show-callout": this.props.show
      });
        return (
            <div className="container" >
                <div className="col-md-6 col-md-offset-3">
                    <div className="row">
                        <div className={calloutClasses} onClick={this.props.hide}>
                            <div className="text-danger alert-icon"></div>
                            <p><i className="fad fa-exclamation-triangle"></i>{this.props.message}</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
});

module.exports = ErrorModal;



// WEBPACK FOOTER //
// ./app/scripts/ui/Login/ErrorModal.react.js